<template>
  <v-form ref="form" @submit.prevent="add">
    <v-textarea v-model="description" label="Description" :rules="[required]" />
    <v-layout justify-space-around>
      <v-btn @click="$router.push(-1)">
        Cancel
      </v-btn>
      <v-btn type="submit" color="primary">
        Add Work Order
      </v-btn>
    </v-layout>
  </v-form>
</template>

<script>
import { db, getUid } from '@/plugins/firebase';
import { required } from '@/util';

export default {
  name: 'AddWorkOrder',
  data: () => ({
    description: null,
    admin: null,
  }),
  async created() {
    const ref = await db
      .collection('users')
      .doc(getUid())
      .get();
    this.admin = ref.get('admin');
  },
  methods: {
    required,
    async add() {
      if (!this.$refs.form.validate()) return;
      await db.collection('orders').add({
        description: this.description,
        createdAt: Date.now(),
        createdBy: getUid(),
        admin: this.admin,
        status: 'open',
      });
      this.$router.push('orders');
    },
  },
};
</script>

<style></style>
